import React, {useEffect, useState} from "react";
import {FormattedMessage} from "react-intl";
import xls from "./images/xls.svg";
import Amount from "../Utils/Amount";
import Help from "../Utils/Help";
import classes from "./styles.module.css";

function RegistryUploadInfo({name, balance, amount, errorsCount, fee, errorsList, errorsFormat}) {
    const [errors, setErrors] = useState([]);
    const [errorsLoading, setErrorsLoading] = useState(true);

    function showErrorsCount(count) {
        if (name && count > 0) {
            return <span className={classes.Error}>{count}</span>;
        }
        return name ? 0 : "—";
    }

    function showCommission(fee) {
        if (!name) return "—";
        const currency = balance && balance.currency ? balance.currency : "";

        const safeFee = Number.isFinite(Number(fee)) ? Number(fee) : 0;
        return <Amount amount={safeFee} currency={currency}/>;
    }


    useEffect(() => {
        if (errorsCount > 0 && errorsList) {
            setErrorsLoading(true);
            const errorsArr = [];

            for (const key in errorsList) {
                if (
                    key !== "count" &&
                    key !== "formatError" &&
                    errorsList[key] &&
                    errorsList[key].expected
                ) {
                    errorsArr.push(errorsList[key].expected);
                }
            }

            setErrors(errorsArr);
            setErrorsLoading(false);
        }
    }, [errorsCount, errorsList]);

    const hasBalance = balance && balance.balance !== undefined;
    const totalCost = (amount || 0) + (fee || 0);
    const hasSufficientBalance = hasBalance && balance.balance >= totalCost;

    return (
        <div className={classes.Upload}>
            <div className={classes.BlockImage}>
                <img src={xls} width="68" height="91" alt="XLS"/>
            </div>

            <div className={classes.BlockInfo}>
                <table className={classes.Table}>
                    <tbody>
                    <tr>
                        <td><FormattedMessage id="RegistryUploadInfo.table.registry" defaultMessage="Реестр:"/></td>
                        <td>{name || "—"}</td>
                    </tr>
                    <tr>
                        <td><FormattedMessage id="RegistryUploadInfo.table.errors" defaultMessage="Ошибок:"/></td>
                        <td>{showErrorsCount(errorsCount)}</td>
                    </tr>
                    <tr>
                        <td><FormattedMessage id="RegistryUploadInfo.table.amount" defaultMessage="Сумма:"/></td>
                        <td>
                            {amount && balance && balance.currency ? (
                                <Amount amount={amount} currency={balance.currency}/>
                            ) : (
                                "—"
                            )}
                        </td>
                    </tr>
                    <tr>
                        <td><FormattedMessage id="RegistryUploadInfo.table.fee" defaultMessage="Комиссия:"/></td>
                        <td>{showCommission(fee)}</td>
                    </tr>
                    <tr>
                        <td><FormattedMessage id="RegistryUploadInfo.table.balance" defaultMessage="Баланс:"/></td>
                        <td>
                            {hasBalance ? (
                                <span className={hasSufficientBalance ? classes.Success : classes.Error}>
                    <Amount amount={balance.balance} currency={balance.currency}/>
                  </span>
                            ) : (
                                "—"
                            )}
                        </td>
                    </tr>
                    </tbody>
                </table>

                {errorsFormat && (
                    <div className={classes.ErrorsList}>
                        <div className={classes.ErrorsTitle}>
                            <FormattedMessage id="RegistryUploadInfo.errors.format" defaultMessage="Ошибка формата файла"/>
                            <div className={classes.ErrorsHelp}>
                                <Help width={140}>
                                    {!errorsLoading &&
                                        errors.map((err, i) => (
                                            <div key={i} className={classes.ErrorsHelpTitle}>
                                                <FormattedMessage
                                                    id="RegistryUploadInfo.errors.missingColumn"
                                                    defaultMessage="Необходимо добавить столбец: {column}"
                                                    values={{column: err}}
                                                />
                                            </div>
                                        ))}
                                </Help>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}

export default RegistryUploadInfo;



// WEBPACK FOOTER //
// ./src/Components/RegistryUploadInfo/index.js